









import { Component } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { LogdownInstance } from '@/types/logdown';
import { StepperEvents } from '../constants/events';
import { Routes } from '../constants/routes';
import { appConfig, isDevelopment } from '@/config/app.config';
import { ConstructionAdvisor, ConstructionStoreActions } from '../store/ConstructionTypes';
import Stepper from '../components/stepper/Stepper.vue';
import { mixins } from 'vue-class-component';
import DataUrlMixin from '../mixins/DataUrlMixin';
import {
    BalConfigState,
    BalSwissLanguage,
    onBalConfigChange,
    updateBalAllowedLanguages,
    updateBalLanguage,
    updateBalRegion,
} from '@baloise/design-system-components';
import { constructionUtil } from '@/app/utils/construction-utils';
import { setLanguage } from '@/app/utils/language-utils';
import { useI18nInstance } from '@/main';

@Component({
    components: {
        Stepper,
    },
})
export default class Start extends mixins(DataUrlMixin) {

    public activeStep = 1;
    public languageSet: boolean = false;

    @Action(ConstructionStoreActions.SaveConstructionAdvisor)
    private readonly saveConstructionAdvisor!: (advisor: ConstructionAdvisor) => void;

    private log!: LogdownInstance;

    public created() {
        this.log = this.$createLogger('Start');
        this.listenOnActivateStep();
        this.parseDataFromUrl();
        this.parseAdvisorNumber();
        updateBalAllowedLanguages(['de', 'fr', 'it']);
    }

    public beforeMount() {
        onBalConfigChange((config: BalConfigState) => {
            const galStackFromUrl = constructionUtil.getStackFromUrl(location.href);

            useI18nInstance.locale = setLanguage(config, this.languageSet, this.$route.query.lang as string);
            this.languageSet = true;
            updateBalLanguage(useI18nInstance.locale as BalSwissLanguage);
            updateBalRegion('CH');

            if (galStackFromUrl && isDevelopment()) {
                this.$router.replace({
                    name: this.$router.currentRoute.name,
                    query: {
                        lang: useI18nInstance.locale as BalSwissLanguage,
                        galstack: galStackFromUrl,
                    },
                });
            } else {
                this.$router.replace({
                    name: this.$router.currentRoute.name,
                    query: {
                        lang: useI18nInstance.locale,
                    },
                });
            }
        });
    }

    public mounted() {
        if (!appConfig.routerDisableRefreshRerouting) {
            this.$router.replace({ name: Routes.ConstructionTypesStep });
        }
    }

    public parseAdvisorNumber() {
        if (this.$route.query.advisorNumber) {
            const advisorNumber: string = this.$route.query.advisorNumber as string;
            this.saveConstructionAdvisor({ advisorText: advisorNumber });
            const query = Object.assign({}, this.$route.query);
            delete query.advisorNumber;
            this.$router.replace({ query });
        }
    }

    private listenOnActivateStep() {
        this.$eventBus.$on(StepperEvents.ActivateStep, (stepToActivate: number) => {
            this.log.info('Set step to active', stepToActivate);
            this.activeStep = stepToActivate;
        });
    }

}
